import React from 'react';
import { 
  HelpCircle, 
  FileText, 
  PiggyBank, 
  Calendar, 
  CreditCard, 
  BookOpen, 
  Globe,
  Home
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Calendar,
      title: 'Сроки подачи декларации',
      description: 'Декларацию 3-НДФЛ нужно подать до 30 апреля года, следующего за отчетным. Для получения вычетов - в течение 3 лет.'
    },
    {
      icon: PiggyBank,
      title: 'Налоговые вычеты',
      description: 'Используйте налоговые вычеты для снижения налоговой базы. Они позволяют вернуть до 13% от расходов на жилье, обучение, лечение и другие цели.'
    },
    {
      icon: CreditCard,
      title: 'Доходы за рубежом',
      description: 'Налоговые резиденты РФ обязаны отчитываться о доходах, полученных за границей, даже если налог там уже уплачен.'
    },
    {
      icon: FileText,
      title: 'Декларация 3-НДФЛ',
      description: 'Подать декларацию можно через личный кабинет налогоплательщика на сайте ФНС, не выходя из дома.'
    },
    {
      icon: BookOpen,
      title: 'Двойное налогообложение',
      description: 'Россия имеет соглашения об избежании двойного налогообложения с более чем 80 странами. Проверьте возможность зачета уплаченного за рубежом налога.'
    },
    {
      icon: Home,
      title: 'Имущественный вычет',
      description: 'При покупке жилья можно вернуть до 260 000 ₽ НДФЛ с расходов до 2 млн ₽ и до 390 000 ₽ с процентов по ипотеке.'
    },
    {
      icon: Globe,
      title: 'Налоговое резидентство',
      description: 'Статус резидента определяется по количеству дней в России: более 183 дней в течение 12 месяцев подряд.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по налогам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <FileText className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Налоговый календарь 2025
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Не пропустите важные даты для подачи деклараций и уплаты налогов
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Скачать календарь
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;